import { isString, parseStringRecord, StringRecord } from "./storageValidation";

const STORAGE_KEY = "kanalearn.achievementsSeen.v1";
// { [achievementId]: "seen" } - which achievement-unlocked toasts have
// already been shown, so a returning visit doesn't re-announce them.
export type AchievementsSeen = StringRecord<string>;

export function getSeen(): AchievementsSeen {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        return parseStringRecord(raw, isString);
    } catch {
        return {};
    }
}

export function setSeen(seen: AchievementsSeen): void {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(seen));
    } catch {
        // Best-effort: if storage is unavailable, the toast may repeat on
        // the next visit, which is harmless.
    }
}
